<template>
  <div>
    <Head title="Edit Knowledge Base Category" />
    <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
      <form @submit.prevent="submit">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Category Name" />
          <select-input v-model="form.parent_id" :error="form.errors.parent_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Parent Category">
            <option :value="null">No Parent</option>
            <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete category</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import { Link, Head } from '@inertiajs/vue3'

export default {
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
    category: Object,
    categories: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.category.name,
        parent_id: this.category.parent_id,
      }),
    }
  },
  methods: {
    submit() {
      this.form.put(this.route('knowledge_base_categories.update', this.category.id))
    },
    destroy() {
      if (confirm('Are you sure you want to delete this category?')) {
        this.$inertia.delete(this.route('knowledge_base_categories.destroy', this.category.id))
      }
    },
  },
}
</script>